export const MenuAboutItems = [
  {
    title: 'Who We Are',
    path: '/about',
    cName: 'dropdown-link',
  },
  {
    title: 'What We Do',
    path: '/what-we-do',
    cName: 'dropdown-link',
  },
  {
    title: 'Our Vision',
    path: '/vision',
    cName: 'dropdown-link',
  },
]
